import { PLATFORM_ID, Component, OnInit, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-trust-pilot',
    templateUrl: './trust-pilot.component.html',
    styleUrls: ['./trust-pilot.component.scss']
})
export class TrustPilotComponent implements OnInit {
  private platformId = inject<Record<string, unknown>>(PLATFORM_ID);


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (window.Trustpilot) {
        const trustboxRef = document.getElementById('trustpilot-box');
        (window.Trustpilot as { loadFromElement: (el: HTMLElement) => void }).loadFromElement(trustboxRef);
      }
    }
  }

}
